<template>
	<div v-if="user && assignCompaniesForm" class="-mx-8">
		<DataTable
				v-model:filters="filters"
				v-model:selection="selectedCompanies"
				:value="companies"
				dataKey="id"
				:globalFilterFields="['name']"
		>
			<template #header>
				<div class="flex items-stretch justify-between px-6 space-x-3">
					<IconField iconPosition="left">
						<InputIcon>
							<i class="pi pi-search" />
						</InputIcon>
						<InputText
                v-model="filters['global'].value"
                :placeholder="$t('pages.admin.users.users.user.companies.user_companies_view.search_companies')"
                class="py-2"
            />
					</IconField>

					<Button :label="$t('common.save')" @click="submit"/>
				</div>
			</template>
			<Column field="name" :header="$t('pages.admin.users.users.user.companies.user_companies_view.name')" class="pl-8"></Column>
			<Column selection-mode="multiple" headerStyle="width: 3rem" headerClass="pr-8"></Column>
		</DataTable>
	</div>
</template>

<script>
import { mapStores } from "pinia";
import { useCompaniesStore } from "@/stores/companies.js";
import { useForm } from "laravel-precognition-vue";
import { FilterMatchMode } from "primevue/api";

export default {
	name: "UserCompaniesView",
	data() {
		return {
			loading: true,
			companies: undefined,
			selectedCompanies: [],
			assignCompaniesForm: undefined,
			filters: {
				global: {
					value: null,
					matchMode: FilterMatchMode.CONTAINS
				},
			}
		}
	},
	computed: {
		...mapStores(useCompaniesStore),
		user() {
			return this.$attrs.user;
		},
	},
	methods: {
		async submit() {
			try {
				this.assignCompaniesForm.company_ids = this.selectedCompanies.map(c => c.id);
				await this.assignCompaniesForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.users.users.user.companies.user_companies_view.companies_updated_for_user'),
          life: 3000
        });
				this.$emit('refresh-user')
			} catch (e) {
				console.log(e);
			}
		}
	},
	async mounted() {
	},

	watch: {
	'user': {
		async handler(newValue) {
			if (newValue) {
				let companiesList = [];
				const authUser = this.$auth.user;

				if (authUser?.permissions?.includes('create:companies')) {
					const response = await this.companiesStore.indexAllCompanies({ per_page: 1000 });
					companiesList = response.data.sort((a, b) => a.name.localeCompare(b.name));
				} else if (authUser?.companies && authUser.companies.length > 0) {
					// For company-admin, show only companies assigned to the logged-in user
					companiesList = authUser.companies.sort((a, b) => a.name.localeCompare(b.name));
				} else {
					this.companies = [];
					this.$toast.error('No companies assigned to your account.');
				}

				this.companies = companiesList;
				// Pre-select companies already assigned to the user being edited
				this.selectedCompanies = companiesList.filter(c => newValue.companies?.some(uc => uc.id === c.id));
				this.assignCompaniesForm = useForm('post', `/users/${newValue.id}/companies`, {
					company_ids: this.selectedCompanies.map(c => c.id)
				});
			} else {
				this.companies = [];
				this.selectedCompanies = [];
				this.assignCompaniesForm = null;
			}
		},
		immediate: true,
	}
	},
}
</script>